<template>
  <v-settings-menu :active="active">
    <v-min-last-price-update namespace="matching" />
    <v-sellers-ids
      namespace="matching"
      prefix="clients"
      prefix-readable="de clientes"
    />
    <v-sellers-ids
      namespace="matching"
      prefix="competitors"
      prefix-readable="de competidores"
    />
    <v-history-ids namespace="matching" />
    <v-matching-brands namespace="matching" />
    <v-show-only-pending-classifications />
    <v-similar-items-fetch />
  </v-settings-menu>
</template>

<script>
import { createNamespacedHelpers } from "vuex";

const { mapState } = createNamespacedHelpers("matching");

import VMatchingBrands from "@/components/settings-menu/MatchingBrands.vue";
import VHistoryIds from "@/components/settings-menu/HistoryIds.vue";
import VMinLastPriceUpdate from "@/components/settings-menu/MinLastPriceUpdate";
import VSettingsMenu from "@/components/settings-menu/Layout";
import VSellersIds from "@/components/settings-menu/SellersIds";
import VShowOnlyPendingClassifications from "./components/ShowOnlyPendingClassifications";
import VSimilarItemsFetch from "./components/SimilarItemsFetch";

export default {
  components: {
    VMatchingBrands,
    VHistoryIds,
    VMinLastPriceUpdate,
    VSellersIds,
    VSettingsMenu,
    VShowOnlyPendingClassifications,
    VSimilarItemsFetch,
  },
  computed: {
    ...mapState(["appSettings"]),
    /**
     * Set as active the menu if there is any non null value in the settings.
     */
    active() {
      return (
        !!this.appSettings.clientsSellersIds.length ||
        !!this.appSettings.competitorsSellersIds.length ||
        !!this.appSettings.historyIds.length ||
        !!this.appSettings.matchingBrands.length ||
        !!this.appSettings.minLastPriceUpdate
      );
    },
  },
};
</script>
